import { assignIn } from 'lodash';

export class TreeArray<T> extends Array<T> {
  filterRec(predicate, childElement: string = 'children'): T[] {
    let found = this.filter(predicate);
    for (const element of this) {
      if (element[childElement] instanceof Array) {
        const treeArray = assignIn(new TreeArray(), element[childElement]);
        found = [...found, ...treeArray.filterRec(predicate)];
      }
    }
    return found;
  }

  findParentRec(predicate, childElement: string = 'children', prevElement): T[] {
    const found = this.find(predicate);
    if (found) {
      return prevElement;
    }
    for (const element of this) {
      if (element[childElement] instanceof Array) {
        const treeArray = assignIn(new TreeArray(), element[childElement]);
        const res = treeArray.findParentRec(predicate, childElement, element);
        if (res) {
          return res;
        }
      }
    }
  }

  findRec(predicate, childElement: string = 'children'): T {
    const found = this.find(predicate);
    if (found) {
      return found;
    }
    for (const element of this) {
      if (element[childElement] instanceof Array) {
        const treeArray = assignIn(new TreeArray(), element[childElement]);
        const res = treeArray.findRec(predicate);
        if (res) {
          return res;
        }
      }
    }
  }
}
